export const FETCH_POSTRETURNS_BEGIN="FETCH_POSTRETURNS_BEGIN";
export const FETCH_ASSETVALUATIONS_SUCCESS="FETCH_ASSETVALUATIONS_SUCCESS";
export const FETCH_POSTRETURNS_FAILURE="FETCH_POSTRETURNS_FAILURE";